export const defaultValues = {
  password: '',
  email: '',
};

export const errorMessages = {
  errors: {
    password: {
      required: 'Enter current password',
    },
    email: {
      required: 'Enter new email',
    },
  },
};
